import React, { createContext, PropsWithChildren, useContext } from 'react';
import { useRouter } from 'next/router';

interface IRouterPathContext {
    asPath?: string,
}

const RouterPathContext = createContext<IRouterPathContext>({});

export const RouterPathProvider = ({
    asPath,
    children,
}: PropsWithChildren<IRouterPathContext>): JSX.Element => (
    <RouterPathContext.Provider value={{ asPath }}>
        {children}
    </RouterPathContext.Provider>
);

export const useRouterAsPath = (): string => {
    const { asPath: contextAsPath } = useContext(RouterPathContext);
    const { asPath } = useRouter();

    return contextAsPath || asPath;
};
